import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export function jumpToAnchor(fragment: string) {
  if (!fragment) { return; }
  const fragments = fragment.split(';');
  setTimeout(() => {
    for (const frag of fragments) {
      const elm = document.getElementById(frag);
      if (!elm) { return; }
      elm.scrollIntoView();
    }
  });
}

export function debugRx(...obs: Observable<any>[]) {
  obs.forEach(o => o.pipe(tap(value => console.warn(value))));
}

export function tapEx<T>(title?: string) {
  title = title || 'tapEx';
  return tap<T>((value: T) => { console.group(title, value); console.groupEnd(); });
}